<template>
    <HeroVideoSingle :shortData="shortData" :data="data" :videoAssetData="mediaDetailsObj" />
    <section class="vid-single-meta">
        <div class="container">
            <!-- <h2 class="section-title">Informatie</h2> -->
            <div v-if="data" class="column-wrapper half-half">
                <div class="column desc" v-if="data.content">
                    <h2 class="column-title">{{ data.title }}</h2>
                    <div v-html="data.subtitle"></div>
                    <!-- <div v-html="data.content"></div> -->

                    <a v-if="data.fields.url && data.fields.url !== ''" target="_blank" class="button extra-btn"
                        :href="data.fields.url">{{ data.fields.label }}</a>
                </div>

                <div class="column meta-list" v-if="data.fields">
                    <ul>
                        <li v-if="data.fields.speaker &&
                            data.fields.speaker.length > 0
                            ">
                            <span class="label">Speakers</span>
                            <span class="value">
                                <span v-for="(item, index) in data.fields.speaker" :key="item.value">
                                    {{ getEnumVal(item.value)
                                    }}<span v-if="index < data.fields.speaker.length - 1">,
                                    </span>
                                </span>
                            </span>
                        </li>

                        <li v-if="mediaDetailsObj">
                            <span class="label">Duration</span>
                            <span class="value">
                                {{ formatToClockDuration(mediaDetailsObj.msDuration) }}
                            </span>
                        </li>

                        <li v-if="data.fields.typeofsession &&
                            data.fields.typeofsession.length > 0
                            ">
                            <span class="label">Type</span>
                            <span class="value">
                                <span v-for="(item, index) in data.fields.typeofsession" :key="item.value">
                                    {{ getEnumVal(item.value)
                                    }}<span v-if="index < data.fields.typeofsession.length - 1">,
                                    </span>
                                </span>
                            </span>
                        </li>
                        <li v-if="data.fields.day &&
                            data.fields.day.length > 0
                            ">
                            <span class="label">Day</span>
                            <span class="value">
                                <span v-for="(item, index) in data.fields.day" :key="item.value">
                                    {{ getEnumVal(item.value)
                                    }}<span v-if="index < data.fields.day.length - 1">,
                                    </span>
                                </span>
                            </span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </section>


    <!-- <div class="related-wrapper" v-if="data && data.relatedContentsExpanded && data.relatedContentsExpanded.length > 0">
        Related stuff
    </div> -->
    <!-- <section class="section related" v-if="playlistItems && playlistItems.length > 0">
        <div class="container">
            <h2 class="section-title">Related videos</h2>
            <div class="column-wrapper">
                <VideoGridCollection :data="playlistItems" />
            </div>
        </div>
    </section> -->

    <section class="section related" v-if="data && data.relatedContents && data.relatedContents.length > 0">
        <PlayList :relatedContents="data.relatedContents" playlistType="overview" @playVideoInPopup="playMediaInPopup()">
            <template v-slot:header>
                &nbsp;
            </template>
        </PlayList>
    </section>

    <transition name="fade">
        <Popup :elemVisible="showTrailerVideo" :elemClass="'mini-popup'" @hidePopupEl="hidePopups()">
            <div class="column video-column">
                <div class="big-wrapper">
                    <button class="close-btn" @click="hidePopups()"></button>
                    <div :id="'popup-trailer-video-' + data.mediaId" style="position: absolute; width: 100%; height: 100%">
                    </div>
                </div>
            </div>
        </Popup>
    </transition>
</template>

<script>
import { mapState } from "vuex";

import {
    fetchVideoContentBySlugDetails,
    fetchVideoContentVideoType,
    fetchVideoAsset,
} from "@streampac.io/chef_sp_1";

// @import component

import HeroVideoSingle from "@/components/HeroVideoSingle";
import PlayList from "@/components/PlayList";

// import VideoPlayerErrorPopup from "@/components/VideoPlayerErrorPopup";

// import PlayList from "@/components/PlayList";

import Popup from "@/components/Popup";

export default {
    inject: ["isAuthenticated"],
    data() {
        return {
            data: null,
            mediaDetailsObj: null,
            shortData: null,
            slug: this.$route.params.slug,
            videos: null,
            getRelatedPlaylist: "",
            storeLoggedInCheck: this.$store.state.isAuthenticated,
            playlistItems: [],
            showTrailerVideo: false,
            // metaFields: {
            // 	themas: [],
            // 	graden: [],
            // 	genre: [],
            // 	land: [],
            // 	dialoog: [],
            // 	kijkwijzer: [],
            // 	ondertiteling: [],
            // 	duratie: null,
            // 	regisseur: null,
            // 	jaar: [],
            // 	tag: [],
            // 	filmfestival: [],
            // },
        };
    },
    components: {
        // VideoPlayerErrorPopup,
        PlayList,
        HeroVideoSingle,
        Popup,
        // PlayList,
    },
    created() {
        this.fetchData();
        this.checkIVidNeedsPlayback();
    },
    computed: mapState(["storeIsAuthenticated"]),
    watch: {
        storeIsAuthenticated(val) {
            if (val == true) {
                this.fetchData();
            }
        },
    },
    methods: {
        hasHistory() {
            return window.history.length > 2;
        },
        hidePopups() {
            this.showMainVideo = false;
            this.showTrailerVideo = false;
        },
        playTrailerVid() {
            this.showTrailerVideo = true;
            this.initTrailerPlayer();
        },
        playMainVid() {
            this.showMainVideo = true;
            // this.initMainPlayer();
        },
        // initMainPlayer() {
        //     const { kWidget } = window;

        //     setTimeout(() => {
        //         kWidget.embed({
        //             targetId: "popup-main-video-" + this.data.mediaId,
        //             wid: "_391",
        //             uiconf_id: 23452148,
        //             flashvars: {
        //                 ks: this.data.kalturaSession,
        //                 playlistAPI: {
        //                     autoPlay: true,
        //                 },
        //             },
        //             entry_id: this.data.mediaId,
        //         });
        //     }, 200);
        // },
        // initTrailerPlayer() {
        //     const { kWidget } = window;

        //     setTimeout(() => {
        //         kWidget.embed({
        //             targetId: "popup-trailer-video-" + this.data.mediaId,
        //             wid: "_391",
        //             uiconf_id: 23452148,
        //             flashvars: {
        //                 ks: this.trailerData.kalturaSession,
        //                 playlistAPI: {
        //                     autoPlay: true,
        //                 },
        //             },
        //             entry_id: this.data.mediaTrailerId,
        //         });
        //     }, 200);
        // },
        fetchData() {
            fetchVideoContentBySlugDetails(
                this.isAuthenticated,
                this.$route.params.slug,
                "?flattenFields=true"
            ).then((response) => {
                this.data = response;

                this.handleRelatedContent();

                //console.log(response);

                // if (
                //     response.relatedPlayList &&
                //     response.relatedPlayList !== ""
                // ) {
                //     this.getRelatedPlaylist = response.relatedPlayList;
                // }

                setTimeout(() => {
                    //Fetch short
                    if (this.data && this.data.mediaShortId !== "") {
                        fetchVideoContentVideoType(
                            this.isAuthenticated,
                            this.data.id,
                            "short?validSeconds=1000"
                        ).then((response) => {
                            this.shortData = response;
                        });
                    }

                    // //Fetch Trailer
                    // if (this.data && this.data.mediaTrailerId !== "") {
                    //     fetchVideoContentVideoType(
                    //         this.isAuthenticated,
                    //         this.data.id,
                    //         "trailer?validSeconds=1000"
                    //     ).then((response) => {
                    //         this.trailerData = response;
                    //     });
                    // }

                    //Fetch video asset data
                    if (this.data.mediaId && this.data.mediaId !== "") {
                        fetchVideoAsset(
                            this.isAuthenticated,
                            this.data.mediaId
                        ).then((response) => {
                            this.mediaDetailsObj = response;
                        });
                    }
                }, 50);
            });
        },
        checkIVidNeedsPlayback() {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);

            if (urlParams && urlParams !== "") {
                const playParam = urlParams.get("play");

                if (playParam && playParam == "true") {
                    setTimeout(() => {
                        this.playMainVid();
                    }, 400);
                }
            }
        },
        getEnumVal(val) {
            const enums = this.$store.state.getEnumLookup;

            if (enums && enums.length > 0) {
                const enumFilter = enums.filter((item) => item.id === val);

                if (enumFilter && enumFilter.length > 0) {
                    return enumFilter[0].enumValue;
                }
            }

            return "";
        },
        padTo2Digits(num) {
            return num.toString().padStart(2, 0);
        },
        formatToClockDuration(milliseconds) {
            let seconds = Math.floor(milliseconds / 1000);
            let minutes = Math.floor(seconds / 60);
            let hours = Math.floor(minutes / 60);

            seconds = seconds % 60;

            minutes = seconds >= 30 ? minutes + 1 : minutes;

            minutes = minutes % 60;

            hours = hours % 24;

            if (hours > 0) {
                return `${this.padTo2Digits(hours)}:${this.padTo2Digits(minutes)}:${this.padTo2Digits(seconds)}`;
            } else {
                return `${this.padTo2Digits(minutes)}:${this.padTo2Digits(seconds)}`;
            }
        },
        handleRelatedContent() {
            if (this.data && this.data.relatedContentsExpanded && this.data.relatedContentsExpanded.length > 0) {

                let adjustedArray = [];

                this.data.relatedContentsExpanded.forEach(function (item) {

                    if (item.entityType === "VideoContent") {

                        if (item.videoContent) {
                            adjustedArray.push(item.videoContent);
                        }

                    } else if (item.entityType === "TemplateContent") {
                        adjustedArray.push(item.templateContent.templateContentFields);
                    }

                });

                this.playlistItems = adjustedArray;

                // console.log(adjustedArray);

                //console.log(adjustedArray);

                this.showPlaylist = true;

            }
        }
    },
};
</script>

<style lang="scss" scoped>
// @import styles
@import "./index.scss";
</style>

<style lang="scss">
.column.desc * {
    line-height: 1.5;
}
</style>
